
import { Component, OnInit } from '@angular/core';
import { AtualizacoesService } from './../atualizacoes.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AgendarAtualizacaoComponent } from '../agendar-atualizacao/agendar-atualizacao.component';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-atualizacoes-disponiveis',
  templateUrl: './atualizacoes-disponiveis.component.html',
  styleUrls: ['./atualizacoes-disponiveis.component.css']
})
export class AtualizacoesDisponiveisComponent implements OnInit {

  dadosAtualizacao: any[];
  cols: any[];
  ref: DynamicDialogRef;
  texto: string = "Uma nova versão do Portal está disponível para atualização! Aproveite as últimas melhorias e recursos adicionados para uma experiência ainda melhor."
  page: any = 1;
  size: any = 10;
  loading: boolean = false;
  first: number = 0;
  displayRows: number = 0;
  totalRecords: number = 0;
  mostrarPaginador: boolean = true;
  mostrarDiv: boolean = false;
  valorId: any;
  username: any;
  data: any;
  dataAtual: string;

  constructor(private service: AtualizacoesService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService) {
    console.log('>>> CONSTRUCTOR - Componente AtualizacoesDisponiveis inicializado');
    this.username = this.service.getUsername();

    this.divToolbar();
  }

  ngOnInit() {
    console.log('>>> ngOnInit - Iniciando componente de atualizações');
    
    // Log da data e hora de Cuiabá ao inicializar o componente
    const agora = new Date();

    const formatter = new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Cuiaba',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(agora);

    // helper para pegar o valor de cada parte
    const get = (type: Intl.DateTimeFormatPartTypes) =>
      parts.find(p => p.type === type)?.value ?? '';

    const dia = get('day');
    const mes = get('month');
    const ano = get('year');
    const hora = get('hour');
    const minuto = get('minute');
    const segundos = get('second');

    const dataFormatada = `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundos}`;

    console.log('>>> Data/Hora de Cuiabá:', dataFormatada);
    console.log('>>> Hora local do computador:', agora.toLocaleString('pt-BR'));

    this.requisicao();
    this.cols = [
      { field: 'versao_api', header: 'Versão Api' },
      { field: 'versao_web', header: 'Versão Web' },
      { field: 'data_versao', header: 'Data da Versão' },
      { field: 'ultima_verificacao', header: 'Ultima Verificação' },
      { field: 'status', header: 'Status' },
      { field: 'msg', header: 'Descrição' },
      { field: 'usuario_aprovou', header: 'Usuário que Aprovou' },
      { field: 'data_aprovacao', header: 'Data da Aprovação' },
      { field: 'data_atualizacao', header: 'Data da Atualização' },
      { field: 'data_agendamento', header: 'Data de Agendamento' }
    ];
  }

  carregarDadosLazy(event: any) {
    this.page = event.page + 1
    this.size = event.rows;
    this.displayRows = event.first;
    this.requisicao();
    this.divToolbar();
  }

  requisicao() {
    this.loading = true;
    this.service.verificaAtualizacoesGet(this.page, this.size).subscribe(res => {
      this.dadosAtualizacao = res;
      if (res.length == 0) {
        this.mostrarPaginador = false;
      } else {
        this.totalRecords = res[0]?.total_registros;
        if (res[0].total_registros < 9) {
          this.mostrarPaginador = false;
          this.divToolbar();
        }
      }
      this.loading = false;
    });
  }

  agendar() {
    let valoresEncontrados = this.dadosAtualizacao.filter((dados) => {
      return dados.status === 'PENDENTE';
    });
    this.ref = this.dialogService.open(AgendarAtualizacaoComponent, {
      header: 'Agendar atualização',
      height: '100%',
      contentStyle: { "max-height": "100%", "overflow": "auto" },
      baseZIndex: 10000,
      data: { chave: valoresEncontrados }
    });
    this.ref.onClose.subscribe(() => {
      this.divToolbar();
      this.requisicao();
    });
  }

  atualizarAgora() {

    // Obtém a data e hora no timezone do servidor (Cuiabá)
    const agora = new Date();

    const formatter = new Intl.DateTimeFormat('pt-BR', {
      timeZone: 'America/Cuiaba',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(agora);

    // helper para pegar o valor de cada parte
    const get = (type: Intl.DateTimeFormatPartTypes) =>
      parts.find(p => p.type === type)?.value ?? '';

    const dia = get('day');
    const mes = get('month');
    const ano = get('year');
    const hora = get('hour');
    const minuto = get('minute');

    this.dataAtual = `${dia}/${mes}/${ano} ${hora}:${minuto}`;

    let valoresEncontrados = this.dadosAtualizacao.filter((dados) => {
      return dados.status === 'PENDENTE';
    });
    this.confirmationService.confirm({
      message: 'Se optar por atualizar agora, todos os usuários logados serão desconectados por alguns minutos!',
      acceptLabel: 'Atualizar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-success',
      rejectButtonStyleClass: 'p-button-danger',
      accept: () => {
        valoresEncontrados.forEach(element => {          
          this.service.atualizarVersao(element.id_update_portal, this.username, this.dataAtual).subscribe();
        });
        setTimeout(() => {
          this.requisicao();
        }, 2000);
        setTimeout(() => {
          this.divToolbar();
        }, 2000);
      }
    });
  }

  getStatusMessage(status: string): string {
    switch (status) {
      case 'PENDENTE':
        return 'PENDENTE';
      case 'APROVADO':
        return 'APROVADO';
      case 'CONCLUIDO':
        return 'CONCLUIDO';
      default:
        return '';
    }
  }


  divToolbar() {
    this.service.agendamento().subscribe(res => {
      if (res[0] != undefined) {
        this.valorId = res[0].id_update_portal;
        this.mostrarDiv = true;
      } else {
        this.mostrarDiv = false;
      }
    });
  }


  reload() {
    this.divToolbar();
    this.requisicao();
  }
}
